__turbopack_context__.v({
  "cta": "EmptyDashboard-module__7OEGdq__cta",
  "root": "EmptyDashboard-module__7OEGdq__root",
  "subtitle": "EmptyDashboard-module__7OEGdq__subtitle",
  "templateCard": "EmptyDashboard-module__7OEGdq__templateCard",
  "templateDescription": "EmptyDashboard-module__7OEGdq__templateDescription",
  "templateTitle": "EmptyDashboard-module__7OEGdq__templateTitle",
  "templates": "EmptyDashboard-module__7OEGdq__templates",
  "title": "EmptyDashboard-module__7OEGdq__title",
});
